<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { Strikethrough } from "ls/common/keyboardShortcuts";
import { StrikethroughIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .setStrike()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :icon="StrikethroughIcon"
    :shortcut="Strikethrough"
    @click="run"
    @keydown.enter="run"
  >
    Strikethrough
  </SuggestionListItem>
</template>
